<i18n>
{
  "fr": {
    "publicId": "ID cantonal",
    "wellDbk": "ID REGIS",
    "station-title": "Sondage: ",
    "show-detail": "Voir plus de détail",
    "hide-detail": "Voir moins de détail",
    "boreholeId": "ID Sondage",
    "zoneId": "ID Zone",
    "observationPointId": "Station SOP-ESO",
    "headLevel": "Niv. nappe (msm)",
    "headDate": "Date relevé nappe",
    "functionType": "Fonction",
    "type": "Type",
    "purpose": "But du sondage",
    "projectType": "Projet",
    "completionDate": "Date de réalisation",
    "depth": "Prof. (m)",
    "diameter": "Diam. (mm)",
    "drillingMode": "Mode de foration",
    "bedrockDepth": "Prof. Rocher",
    "testing": "Essais (in-situ, labo)",
    "xCrd": "X",
    "yCrd": "Y",
    "heightBsl": "Z (msm)",
    "remark": "Remarque",
    "privacy": "Accès",
    "yes": "oui",
    "no": "non"
  },
  "de": {

  }
}
</i18n>

<template>
  <div id="obsPoint-info" class="tool" v-if="show">
    <div class="header">
      <div class="header-content">
        <h3>{{ $t('station-title') }} {{ currentObject.name }}</h3>
        <div class="action">
          <md-button :class="['md-icon-button', 'md-raised', 'md-dense', { 'md-primary': showDetail }]"
            @click="toggleDetail">
            <md-icon>read_more</md-icon>
            <md-tooltip>{{ $t(showDetail ? 'hide-detail' : 'show-detail') }}</md-tooltip>
          </md-button>
        </div>
      </div>
    </div>


    <div class="main-container">
      <div class="info" v-if="showDetail">
        <h4>{{ $t('boreholeId') }}</h4>
        <span class="info-value"><a
            :href="`https://geocadast.crealp.ch/index.php?lang=FR&view=sondage&mode=rapport&id=${currentObject.boreholeId}`"
            target="_blank">{{ currentObject.boreholeId }}</a></span>
      </div>


      <div class="info">
        <h4>{{ $t('zoneId') }}</h4>
        <span class="info-value">{{ currentObject.zoneId }}</span>
      </div>

      <div class="info">
        <h4>{{ $t('observationPointId') }}</h4>
        <span class="info-value" v-for="item in foundInLayers[0]?.found" :key="item.properties.oid"
          @click="inLayerSelected(item, foundInLayers[0].layer)">
          <a v-if="foundInLayers[0]" class="cursor-pointer">{{ `${item.properties.name} ${item.properties?.nom ? '- ' +
    item.properties.nom :
    ''}` }}</a>
        </span>
        <span class="info-value" v-if="!foundInLayers[0]">-</span>
      </div>



      <div class="info">
        <h4>{{ $t('headLevel') }}</h4>
        <span class="info-value">{{ currentObject.headLevel }}</span>
      </div>

      <div class="info">
        <h4>{{ $t('headDate') }}</h4>
        <span class="info-value">{{ currentObject.headDate | formatDate }}</span>
      </div>

      <template v-if="showDetail">

        <div class="info">
          <h4>{{ $t('xCrd') }}</h4>
          <span class="info-value">{{ currentGeom.coordinates[0] | formatCoordinate }}</span>
        </div>

        <div class="info y-crd">
          <h4>{{ $t('yCrd') }}</h4>
          <span class="info-value">{{ currentGeom.coordinates[1] | formatCoordinate }}</span>
        </div>

        <div class="info y-crd">
          <h4>{{ $t('heightBsl') }}</h4>
          <span class="info-value">{{ currentObject.heightBsl }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('type') }}</h4>
          <span class="info-value">{{ currentObject.type }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('purpose') }}</h4>
          <span class="info-value">{{ currentObject.purpose }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('functionType') }}</h4>
          <span class="info-value">{{ currentObject.functionType }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('projectType') }}</h4>
          <span class="info-value">{{ currentObject.projectType }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('completionDate') }}</h4>
          <span class="info-value">{{ currentObject.completionDate | formatDate }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('depth') }}</h4>
          <span class="info-value">{{ currentObject.depth }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('diameter') }}</h4>
          <span class="info-value">{{ currentObject.diameter | formatDiameter }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('drillingMode') }}</h4>
          <span class="info-value">{{ currentObject.drillingMode }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('bedrockDepth') }}</h4>
          <span class="info-value">{{ currentObject.bedrockDepth | formatNullValue }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('testing') }}</h4>
          <span class="info-value">{{ booleanToFrench(currentObject.testing) }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('remark') }}</h4>
          <span class="info-value">{{ currentObject.remark | formatNullValue }}</span>
        </div>

        <div class="info">
          <h4>{{ $t('privacy') }}</h4>
          <span class="info-value">{{ booleanToFrench(!currentObject.privacy) }}</span>
        </div>

      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import MapStoreMixin from '@/mixins/store/map'
import LayerStoreMixin from '@/mixins/store/layer'
import ToolStoreMixin from '@/mixins/store/tool'
import camelize from 'camelize'
import InteractionMixin from '@/mixins/store/interaction'
import { Style, Icon } from 'ol/style'
import DefaultObsPointHover from '@/assets/icons/hover-icons/default-obs-point-hover.svg'

export default {
  name: 'ObsPointDescription',
  mixins: [
    MapStoreMixin,
    InteractionMixin,
    LayerStoreMixin,
    ToolStoreMixin
  ],
  props: {
    params: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return  {
      showDetail: false,
      foundInLayers: [],
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.updateTool()
    })
    this.presentIn()
  },
  beforeDestroy() {
    this.removeTool()
    this.clearHoverFeature()
  },
  watch: {
    currentGeom () {
      this.updateTool()
    },
    selectedLayers () {
      this.updateTool()
      this.presentIn()
    }
  },
  computed: {
    nodata () {
      return !this.loading && _.isEmpty(this.currentObject)
    },
    show () {
      return this.currentGeom !== null && this.selectedLayers.length > 0
    },
    hasRemoteData () {
      return this.datasources?.filter((ds) => ds.datasourceType.code === 'remote').length > 0
    },
    datasources () {
      if (_.isEmpty(this.currentObject)) return []
      return this.currentObject.datasources
    },
    workingState () {
      let datasources = this.datasources?.filter((ds) => _.includes(this.params.parameterTypeCodes, ds.parameterType.code))
      let datasourcesNodata = this.hasRemoteData ? datasources.filter((ds) => ds.workingState === 'nodata' && ds.datasourceType.code === 'remote') : this.datasources.filter((ds) => ds.workingState === 'nodata' && ds.datasourceType === 'validated')
      let datasourcesWarn = datasources.filter((ds) => ds.workingState === 'warn')
      let datasourcesErr = datasources.filter((ds) => ds.workingState === 'err')

      if (datasourcesNodata.length > 0) return 'nodata'
      if (datasourcesErr.length > 0) return 'err'
      if (datasourcesWarn.length > 0) return 'warn'
      return 'ok'
    }
  },
  filters: {
    formatDate(value) {
        if (value) {
            const date = new Date(value);
            return new Intl.DateTimeFormat('fr-CH', {
                day: '2-digit', month: '2-digit', year: 'numeric'
            }).format(date);
        }
        return '-';
    },
    formatDiameter(value) {
        if (!value && value !== 0) return '-';  
        return `${parseFloat(value).toFixed(0)}`; 
    },
    formatNullValue (value) {
      if (value === '' || value === 'N/A') return '-'
      return value
    },
    formatDepth (value) {
      if (value === '' || value === '999.99') return '-'
      return `${parseFloat(value).toFixed(2)} m`
    },
    formatCoordinate (value) {
      if (value === undefined) return ''

      return new Intl.NumberFormat('fr-CH', {
        style: 'decimal'
      }).format(value.toFixed(0)).replaceAll(' ', '\'')
    }
  },
  methods: {
    updateTool () {
      if (this.selectedLayers.length > 0 && this.currentGeom !== null && this.currentObject !== null) {
        this.load()
      } else {
        this.removeTool()
      }
    },
    inLayerSelected (item, layer) {
      
    
      this.setCurrentGeom(item.geometry)
      this.setCurrentObject(camelize(item.properties))
      this.centerTo(item.geometry.coordinates, layer.webviewConfig.zoomToFeature)
      this.selectLayer(layer)
      setTimeout(() => {
        this.selectLayer(layer)
      }, "500");

    },
    removeTool () {
      if (this.hoverLayer === null) return
      this.mapRef.removeLayer(this.hoverLayer)
      this.hoverLayer = null
    },
    load () {
      this.showDetail = this.params.showDetail

      this.setHoverGeoJSON(this.currentGeom)
      this.setHoverStyle(new Style({
        image: new Icon({
          opacity: 1,
          src: DefaultObsPointHover,
          scale: 0.35
        })
      }))
    },
    toggleDetail () {
      this.showDetail = !this.showDetail
    },
    gotoObsPointAdmin () {
      let url = this.$router.resolve({ name: 'admin-observation-point-data', params: { id: this.currentObject.id } })
      window.open(url.href, '_blank')
    },
    booleanToFrench(value) {
      return value ? this.$t('yes') : this.$t('no');
    },
    async presentIn (){
      this.foundInLayers = []
      if (this.currentObject.observationPointName === '') return
        let results = []

        for (let layer of this.layerGroupInfo.layers.getArray()) {
          try {
            let [featureCollection, featuresByPublicId] = await Promise.all([
              layer.searchFeatures(this.currentObject.observationPointName),
              layer.searchFeatures(this.currentObject.observationPointName, 'public_id')
            ])
            featureCollection.features = _.uniqBy(featureCollection.features.concat(featuresByPublicId.features), 'id')
            results.push({
              layer,
              featureCollection
            })
          } catch {
            // Pas de problème si pas de données...
          }
        }

        results.forEach(({ layer, featureCollection }) => { 
          if (featureCollection.features.length && layer.metadata.name !== "Sondages (Géocadast)" ) {
            this.foundInLayers.push({
              layer,
              found: _.orderBy(featureCollection.features, ['properties.name'], ['asc'])
            })
          }
        })
      
    }    
  }
}
</script>

<style lang="scss" scoped>
#obsPoint-info {
  width: 100%;

  .header {
    display: flex;
    flex-direction: column;

    .header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .main-container {
    overflow-y: auto;
    overflow-x: hidden;
    background: none;

    padding-left: 23px;
    padding-right: 23px;

    @media (max-height: 500px) {
      max-height: 100vh;
    }
  }

  .container {
    margin-left: -10px;
    margin-right: -10px;
    background-color: white;

    h2 {
      margin-top: 5px;
    }
  }

  h3 {
    max-width: 17vw;
  }

  h4 {
    margin: 0px;
    font-size: 13px;
  }


  .info {
    display: flex;
    align-items: center;
    margin-top: 10px;

    h4 {
      min-width: 140px;
    }

    .sub-h4 {
      margin: 0px;
      font-size: 12px;
      min-width: 140px;
    }

    .info-value {
      margin-left: 5px;
    }

    .sub-info-value {
      margin-left: 5px;
      font-size: 12px;
    }


    .cursor-pointer {
      cursor: pointer;
    }

    &.y-crd {
      margin-top: -5px;
    }
  }
}
</style>
